<template>
    <div v-if="value != null">
        <i v-if="value > 86" class="fa fa-battery-full"></i>
        <i v-else-if="value > 45" class="fa fa-battery-three-quarters"></i>
        <i v-else-if="value > 30" class="fa fa-battery-half"></i>
        <i v-else-if="value > 15" class="fa fa-battery-quarter"></i>
        <i v-else class="fa fa-battery-empty"></i>
        <!--{{value}}%-->
    </div>
</template>

<script>
    export default {
        name: 'Battery',
        props: ['value']
    }
</script>

<style scoped>
    .fa-battery-full {
        color: #05B408;
    }
    .fa-battery-three-quarters {
        color: #05B408;
    }
    .fa-battery-half {
        color: #F6AF00;
    }
    .fa-battery-quarter {
        color: #c9302c;
    }
    .fa-battery-empty {
        color: #c9302c;
    }
</style>
